export default __webpack_public_path__ + "static/media/7.7d633dd4.png";